import { PDFDocument, PDFFont, PDFPage, rgb, StandardFonts } from 'pdf-lib';
import SAModule from "./bridgeModule";
import { deleteObject, getStorage, listAll, ref, uploadBytes } from 'firebase/storage';
import { branch, companyDir } from './StockAwareTempData';

type SalesData = {
  qty: string;
  desc: string;
  amt: string;
};

type ReceiptData = {
  name: string;
  address: string;
  phone: string;
  salesID: string;
  salesPerson: string;
  date: string;
  payment: string;
  customer: string;
  total: string;
  discount: string;
  totalPaid: string;
};

export async function createAndSavePDF(salesData: SalesData[], receiptData: ReceiptData) {
  const cmToPoints = (cm: number) => cm * 28.3465;
  try {
    const pdfDoc = await PDFDocument.create();

    const pageWidthCm = 7.2;
    const pageHeightCm = 29.7;
    const pageWidthPoints = cmToPoints(pageWidthCm);
    const pageHeightPoints = cmToPoints(pageHeightCm);
    console.log(cmToPoints(pageHeightCm))

    const page = pdfDoc.addPage([pageWidthPoints, pageHeightPoints]);

    const HelveticaBold = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const Helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const HelveticaOblique = await pdfDoc.embedFont(StandardFonts.HelveticaOblique);
    const fontSize = 7.5;
    const lineHeight = 10;
    const fontColor = rgb(0, 0, 0);
    let startY = 0;
    const stockAware = receiptData.name;
    const fontSSize = 10;
    const stockAwareX = (page.getWidth() - Helvetica.widthOfTextAtSize(stockAware, fontSSize)) / 2;
    const stockAwareY = page.getHeight() - 10
    const sumWidth = HelveticaBold.widthOfTextAtSize('Sum (N)', fontSize);
    const address = receiptData.address;
    const phone = receiptData.phone
    
    const autoFill = (page: PDFPage, text: string, maxWidth: number, x: number, y: number, font: PDFFont, fontSize: number) => {

      page.drawText(text, {
        x: x,
        y: y,
        size: fontSize,
        font: font,
        color: fontColor,
        maxWidth:maxWidth,
        lineHeight:lineHeight,
      });
    }

    autoFill(page, stockAware, 150, stockAwareX , stockAwareY, HelveticaBold, fontSSize );

    autoFill(page, 'Address:', 150, 20, stockAwareY - 15, HelveticaBold, fontSize );
    autoFill(page, address, 123, 55, stockAwareY - 15, Helvetica, fontSize );

    autoFill(page, 'Contact Us:', 50, 20, stockAwareY - 35, HelveticaBold, fontSize );
    autoFill(page, phone, 100, 65, stockAwareY - 35, Helvetica, fontSize );

    autoFill(page, 'Sales ID:', 50, 5 , stockAwareY - 55, HelveticaBold, fontSize );
    autoFill(page, receiptData.salesID, 50, 40 , stockAwareY - 55, Helvetica, fontSize );

    autoFill(page, 'Sales Person:', 50, 5 , stockAwareY - 65, HelveticaBold, fontSize );
    autoFill(page, receiptData.salesPerson, 150, 58 , stockAwareY - 65, Helvetica, fontSize );

    autoFill(page, 'Purchase Date & Time:', 100, 5 , stockAwareY - 75, HelveticaBold, fontSize );
    autoFill(page, receiptData.date, 150, 90 , stockAwareY - 75, Helvetica, fontSize );

    autoFill(page, 'Receipt Time Stamp:', 100, 5 , stockAwareY - 85, HelveticaBold, fontSize );
    autoFill(page, new Date().toISOString(), 150, 80 , stockAwareY - 85, Helvetica, fontSize );
 
 
    autoFill(page, 'Qty', 16.7, 5, page.getHeight() - 120, HelveticaBold, fontSize)
    autoFill(page, 'Board Description', 135.6, 25, page.getHeight() - 120, HelveticaBold, fontSize )
    autoFill(page, 'Sum (N)', 41.7, page.getWidth() - 5 - sumWidth, page.getHeight() - 120, HelveticaBold, fontSize )

    for (const entry of salesData) {
      const textWidth = Helvetica.widthOfTextAtSize(entry.desc, fontSize);
      const amtWidth = Helvetica.widthOfTextAtSize(entry.amt, fontSize);
     
      autoFill(page, entry.qty, 16.7, 5, page.getHeight() - 135 - (startY * 10), Helvetica, fontSize );
      autoFill(page, entry.desc, 135.6, 25, page.getHeight() - 135 - (startY * 10), Helvetica, fontSize);
      autoFill(page, entry.amt, 41.7, page.getWidth() - 5 - amtWidth, page.getHeight() - 135 - (startY * 10), Helvetica, fontSize );

      let num = ( textWidth / 135.6 ) 
      do {
        startY += 1
        num -= 1
      } while (num > 0);
    }
    page.drawLine({
      start: { x: 160, y: page.getHeight() - 135 - (startY * 10) + 5 },
      end: { x: 201.7, y: page.getHeight() - 135 - (startY * 10) + 5 },
      thickness: 1,
      color: fontColor,
      opacity: 1,
    })

    autoFill( page, 'Sum Total', 100, 5, page.getHeight() - 135 - (startY * 10) - 5, HelveticaBold, fontSize );

    autoFill(
      page, 
      receiptData.total, 41.7, 
      page.getWidth() - 5 - Helvetica.widthOfTextAtSize(receiptData.total, fontSize), 
      page.getHeight() - 135 - (startY * 10) - 5, 
      Helvetica, 
      fontSize );

    autoFill(page, 'Discount', 100, 5 , page.getHeight() - 135 - ((startY + 1) * 10) - 5 , Helvetica, fontSize );
    autoFill(page, receiptData.discount, 50, page.getWidth() - 5 - Helvetica.widthOfTextAtSize(receiptData.discount, fontSize),
     page.getHeight() - 135 - ((startY + 1) * 10) - 5 , Helvetica, fontSize );

    page.drawLine({
      start: { x: 160, y: page.getHeight() - 135 - ((startY + 2) * 10) },
      end: { x: 201.7, y: page.getHeight() - 135 - ((startY + 2) * 10) },
      thickness: 1,
      color: fontColor,
      opacity: 1,
    })

    autoFill(page, 'Total Amount Paid', 150, 5 , page.getHeight() - 135 - ((startY + 1) * 10) - 20 , HelveticaBold, fontSize );
    autoFill(page, receiptData.totalPaid, 50, page.getWidth() - 5 - Helvetica.widthOfTextAtSize(receiptData.totalPaid, fontSize),
     page.getHeight() - 135 - ((startY + 1) * 10) - 20 , Helvetica, fontSize );

    page.drawLine({
      start: { x: 160, y: page.getHeight() - 135 - ((startY + 3) * 10) -5 },
      end: { x: 201.7, y: page.getHeight() - 135 - ((startY + 3) * 10) -5 },
      thickness: 1,
      color: fontColor,
      opacity: 1,
    })

    autoFill(page, 'Payment Method:', 100, 5 , page.getHeight() - 135 - ((startY + 3) * 10) - 30 , HelveticaBold, fontSize );
    autoFill(page, receiptData.payment, 50, 70 , page.getHeight() - 135 - ((startY + 3) * 10) - 30 , Helvetica, fontSize );

    autoFill(page, 'Customer Name:', 100, 5 , page.getHeight() - 135 - ((startY + 4) * 10) - 30 , HelveticaBold, fontSize );
    autoFill(page, receiptData.customer, 50, 68 , page.getHeight() - 135 - ((startY + 4) * 10) - 30 , Helvetica, fontSize );

    page.drawLine({
      start: { x: 4, y: page.getHeight() - 135 - ((startY + 4) * 10) - 45 },
      end: { x: 201.7, y: page.getHeight() - 135 - ((startY + 4) * 10) - 45 },
      thickness: 1,
      color: fontColor,
      opacity: 1,
    })

    autoFill(page, 'PAID AND DELIVERED', 200, 52 , page.getHeight() - 135 - ((startY + 4) * 10) - 58.5 , HelveticaOblique, fontSize + 2 );

    page.drawLine({
      start: { x: 4, y: page.getHeight() - 135 - ((startY + 4) * 10) - 65 },
      end: { x: 201.7, y: page.getHeight() - 135 - ((startY + 4) * 10) - 65 },
      thickness: 1,
      color: fontColor,
      opacity: 1,
    })
   
    //const base64PDF = await pdfDoc.saveAsBase64({ dataUri: false });
    
    //await SAModule.writePrintFile(base64PDF);
  
    //return { base64PDF };
    const pdfFile = await pdfDoc.save()

    const pdfBlob = new Blob([pdfFile], { type: 'application/pdf'  });

    // Create a URL for the Blob
    const pdfUrl = URL.createObjectURL(pdfBlob);
    
    // Create a hidden iframe element
    const printFrame = document.createElement('iframe');
    printFrame.style.display = 'none';
    printFrame.title = 'StockAwareReceipt'

    // Set the iframe's source to the PDF URL
    printFrame.src = pdfUrl;

    // Append the iframe to the document body
    document.body.appendChild(printFrame);

    // Function to trigger the print dialog

    printFrame.contentWindow.print();
    //window.open(pdfUrl, '_blank');



    const storage = getStorage();
    
    const storageRef = ref(storage, "gs://willijofirebase.appspot.com");
    const pdfsRef = ref(storageRef, companyDir + '-' + branch + '-' + receiptData.salesID + '.pdf');

    await uploadBytes(pdfsRef, pdfFile, { contentType: "application/pdf" });



    



    



    try {
      // List all files in the storage bucket
      const result = await listAll(storageRef);
  
      for (const itemRef of result.items) {
        try {
          // Download the file to a local directory
          const downloadUsingHost = 'http://localhost:3000/download/' + itemRef.name; //used for download through server to bypass cors
          //const downloadURL = await getDownloadURL(itemRef);
          // const encodedDownloadURL = encodeURIComponent(downloadURL);
          // const runServerScript = `http://localhost:3000/run-powershell-script?downloadURL="${encodedDownloadURL}"`;
  
          // fetch(runServerScript)
          //   .then((response) => response.blob())
          //   .then((blob) => {
          //     // Create a URL for the blob   
          //     const blobUrl = URL.createObjectURL(blob);
          //     // Create a link element to trigger the download  
          //     const link = document.createElement('a');
          //     link.href = blobUrl;
          //     //link.download = itemRef.name; // Specify the desired file name
          //     link.click();
              
          //     return blobUrl
  
          //   })
          //   .then(async (blobUrl) => {
          //     await URL.revokeObjectURL(blobUrl);
          //     await deleteObject(itemRef);              
          //   })
          //   .catch((error) => {
          //     console.error('Error downloading file:', error);
          //   })
  
          fetch(downloadUsingHost)
          .then((response) => response.text()) // Assuming the server sends back a text response
          .then(async (responseText) => {
            await deleteObject(itemRef);
          })
          .catch((error) => {
            console.error('Error:', error);
          });
  
          console.log('File deleted from Firestore Cloud Storage');
        } catch (error) {
          console.error('Error processing file:', error);
        }
      }
      // Sleep for a specified duration before checking again (e.g., every 5 minutes)
      await new Promise((resolve) => setTimeout(resolve, 30000)); // 5 minutes
    } catch (error) {
      console.error('Error listing files:', error);
    }









  } catch (error) {
    console.error('Error creating the PDF:', error);
    return null;
  }
}

export default createAndSavePDF;










// async function fetchAndConvertToBase64(imageUrl: string) {
//   try {
//     const response = await fetch(imageUrl);
//     const imageBlob = await response.blob();
//     const base64 = await blobToBase64(imageBlob);
//     const base64String: string = base64 as string;
//     return base64String;
//   } catch (error) {
//     console.error('Error fetching or converting image:', error);
//     throw error;
//   }
// }

// async function blobToBase64(blob: Blob) {
//   return new Promise((resolve, reject) => {
//     const reader = new FileReader();
//     reader.onload = () => {
//       if (typeof reader.result === 'string') {
//         resolve(reader.result.split(',')[1]);
//       } else {
//         reject(new Error('Failed to convert Blob to base64'));
//       }
//     };
//     reader.onerror = error => {
//       reject(error);
//     };
//     reader.readAsDataURL(blob);
//   });
// }

// const pdfBytes = await pdfDoc.save();
    // const pdfByteArray = Array.from(pdfBytes);
    // const base64EncodedPDF =   btoa(pdfByteArray.map(byte => String.fromCharCode(byte)).join('')); // Option 1
   
    // const base64EncodedPDFl = btoa(String.fromCharCode(...pdfBytes)); // Option 2
    // const mimeType = 'application/pdf';
    // const dataUri = `data:${mimeType};base64,${base64EncodedPDF}`; // Data Uri

    // const base64EncoedPDF = btoa(String.fromCharCode.apply(null, pdfByteArray)); // Option 3


